module.exports = __webpack_public_path__ + "static/media/Heracles.7f8af73b.jpg";